/* eslint no-mixed-operators:0 */

import { useState, useContext, useEffect } from 'react';
import {
  Button,
  Box,
  ButtonGroup,
  InputLabel,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  TextField
} from '@mui/material';

import {
  DeleteForever as DeleteForeverIcon,
  Add as AddIcon,
} from '@mui/icons-material';

import { Layout as DashboardLayout } from 'layouts/portal/layout';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { Tracking } from 'components/Tracking';
import { AuthContext, EditCollection } from 'components';


export const CollectionsView = (props) => {
  const [ deleteModalOpen, setDeleteModalOpen ] = useState(false);
  const [ collectionToDelete, setCollectionToDelete ] = useState(null);
  const [ newCollection, setNewCollection ] = useState("")
  const { collections, addCustomCollection, deleteCustomCollection, sortCustomCollection, sortByDisplayOrder, uploadMissingImage } = useContext(AuthContext);
  const [ visibleCollections, setVisibleCollections ] = useState([])

  useEffect(() => { 
    Tracking.track('Portal - Collections')
    // uploadMissingImage()
  }, [])
  
  useEffect(() => { 
    setVisibleCollections(Object.keys(collections).filter(e => ['all', '-'].indexOf(e) === -1).map(e => ({ ...collections[e], id: e })).sort(sortByDisplayOrder))
  }, [collections])

  const handleAddCollection = () => {
    if (newCollection) {
      let displayOrder = (Object.keys(collections).length -1) * 10
      addCustomCollection({
        displayName: newCollection,
        displayOrder: displayOrder || 10
      }, () => {
        setNewCollection("")
      })
    }
  }

  const handleDeleteModalOpen = (collection) => {
    setCollectionToDelete(collection.id)
    setDeleteModalOpen(true);
  }

  const handleDeleteModalClose = () => {
    setCollectionToDelete(null)
    setDeleteModalOpen(false);
  }

  const handleDeleteCollection = () => {
    deleteCustomCollection(collectionToDelete, () => {
      handleDeleteModalClose()
    })
  }

  const handleDragEnd = (r) => {
    sortCustomCollection(visibleCollections.map(c => c.id), r.draggableId, r.source.index, r.destination.index)
  }

  return (
    <DashboardLayout>
      <Typography variant="h2">Collections</Typography>
      <Typography variant="body1">Drag collections to change the order</Typography>

      <Box
        component="main"
        sx={{
          flexGrow: 1
        }}
      >
        <DragDropContext
          onDragEnd={handleDragEnd}
        >
          <Droppable droppableId={`add-custom-collection`}>
            {provided => (
              <List 
                sx={{ maxWidth: 400 }}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                <ListItem
                  sx={{ pl: 0 }}
                  key={`add-custom-collection`}
                  secondaryAction={
                    <IconButton disabled={!newCollection} onClick={handleAddCollection} color="primary" edge="end" aria-label="Add collection">
                      <AddIcon />
                    </IconButton>
                  }
                >
                  <ListItemButton role={undefined} dense>
                    <TextField 
                      InputProps={{
                        style: { 
                          minHeight: 'auto',
                        }
                      }}
                      sx={{
                        flexGrow: 1
                      }}
                      value={newCollection}
                      onChange={(e) => setNewCollection(e.target.value)}
                      onKeyDown={e => { if(e.key === 'Enter') { handleAddCollection() } }}
                      size="small"
                      label="Add Collection"
                      variant="standard" 
                    />
                  </ListItemButton>
                </ListItem>
                {visibleCollections.map((option, index) => {
                  if (!option.id) return

                  return (
                    <Draggable
                      draggableId={option.id}
                      index={index}
                      key={`${option.id}`}
                    >
                      {provided_children => (
                        <ListItem
                          sx={{ pl: 0 }}
                          secondaryAction={
                            <>
                              <EditCollection title={option.displayName} collection={option} />
                              <IconButton onClick={() => { handleDeleteModalOpen(option) }} edge="end" aria-label="Delete collection">
                                <DeleteForeverIcon />
                              </IconButton>
                            </>
                          }
                          {...provided_children.draggableProps}
                          {...provided_children.dragHandleProps}
                          ref={provided_children.innerRef}
                        >
                          <ListItemButton role={undefined} dense>
                            <ListItemText primary={option.displayName} />
                          </ListItemButton>
                        </ListItem>
                      )}
                    </Draggable>
                  )
                })}
                <Dialog
                  open={deleteModalOpen}
                  onClose={handleDeleteModalClose}
                >
                  <DialogTitle>
                    Delete Collection?
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText sx={{ textAlign: 'center' }}>
                      <span>Tap the Delete button to delete this collection. This does not delete any products.</span>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleDeleteModalClose}>Cancel</Button>
                    <Button color="error" onClick={handleDeleteCollection} autoFocus>Delete</Button>
                  </DialogActions>
                </Dialog>
                {provided.placeholder}
              </List>
            )}
          </Droppable>
        </DragDropContext>
      </Box>
    </DashboardLayout>
  );
}
